import slick from 'jquery_version/slick.js';
// import imgLiquid from 'plugs/imgLiquid-min.js';
// import fullpage from 'fullpage.js'
import 'svg.js';
import 'jquery.easing.1.3.js';;
import 'jquery.mCustomScrollbar.concat.min.js';
// import 'fullpage.extensions.min.js';
import 'scrolloverflow.min.js';
import 'jquery_version/jquery.validate.min.js';


$(document).ready(function () {
  $('body').addClass('loading');

  $("html,body").animate({
    scrollTop: $(this).scrollTop() - 1
  }, 10);

  /* ==========================================================================
                * ALL
    ==========================================================================*/
  var $window = $(window);
  var windowHeight = $(window).height();
  var windowWidth = $(window).width();
  var footerHeight = $('footer').height();

  ScrollFade();
  // TopMenu();
 /* ==========================================================================
                * 鼠標
    ==========================================================================*/
    // $(document).mousemove(function(e){
    //   $('.curcil').css(
    //     {
    //       left: e.pageX,
    //       top: e.pageY - scrollTop
    //     }
    //   )
    // })
    // $('a,input,select,textarea,label').mouseenter(function(e){
    //   $('.curcil').css(
    //     {
    //       opacity: 0
    //     }
    //   )
    // })
    // $('a,input,select,textarea,label').mouseleave(function(e){
    //   $('.curcil').css(
    //     {
    //       opacity: 1
    //     }
    //   )
    // })
    var old_w;
    $(window).on('resize', function(event) {
      var winW = $(window).width();
      if ($('#top-menu-ul').length > 0) {
        
        
        if (old_w != winW) {
          var menu_ul = $('#top-menu-ul ul').width();
          var menu_box = $('#top-menu-ul .item_menu_Box').width();
          $('#top-menu-ul').removeClass('open_flexslider');
          $('#top-menu-ul .slides').removeAttr('style');
          $('#top-menu-ul .item_menu_Box').removeAttr('style');
          if (menu_ul > menu_box) {
            $('#top-menu-ul').addClass('open_flexslider');
            var m_menubox = $('.item_menu_Box').width();
            var m_start = $('.item_menu_list li:nth-child(1) a').width();
            var m_end = $('.item_menu_list li:last-child a').width();
            console.log(m_start);
            console.log(m_menubox);
            $('.item_menu_list').css({
              'padding-left': (m_menubox - m_start) / 2,
              'padding-right': (m_menubox - m_end) / 2
            });
          }
  
          slider_ul_list();
        }
        old_w = winW;
      }
    }).resize();

    
     //menu scroll
    function slider_ul_list() {  
      var newscroll=0;
      var move = new Array();
      var total_width = 0;
      var i = 0;
      var sum = 0;
      var sumArray = new Array();
      var total = $("#top-menu-ul li");
      var active = $("#top-menu-ul .slides .active").index();
      total_width = $("#top-menu-ul ul").width();//1043.4
      total.each(function(){
          move[i] = $(this).width();
          sum += move[i];
          sumArray[i] = sum;
          i++;
      });
      
      sum = Math.round(( total_width - sum ) / i);
      for(var j=0;j<i;j++) move[j] += sum; 
      sum = 0;
      
      if($('#top-menu-ul').hasClass('open_flexslider')){
          var item_w = $("#top-menu-ul ul").width();
          var list_width = $('#top-menu-ul .item_menu_Box').width();    
          var active_offset = $('.item_menu_list li.active').offset().left;
          var active_width = $("#top-menu-ul .slides li").eq(active).width() ;
          var active_pos = (list_width - active_width) / 2;
          sum = active_offset - active_pos - 60;
          if(active > 0){$('#top-menu-ul .item_menu_Box').scrollLeft(sum);}
          else{newscroll=0;}
          var j = 0;
          var move_total = 0;
          for (var ac = 0; ac <= active ; ac++){
              move_total = ac > 0 ? (move_total + move[ac-1]) : 0;
              if(move_total > (total_width - list_width)) move_total = (total_width - list_width);
              else j = ac;
          }
          (ac - j) > 1 ? j++ : "";
          move_total = Math.floor(move_total);
          $(".item_menu_Box").on('scroll',function(){
              newscroll = $('#top-menu-ul .item_menu_Box').scrollLeft();            
          });
          $("#top-menu-ul .flex-next").on('click',function(){
              if(newscroll == move_total){
                  if(move_total < (total_width - list_width) && j < i){
                      j++;
                      move_total = 0;
                      for (var k = 0; k < j ; k++) move_total += move[k];
                      move_total = move_total > (total_width - list_width) ? (total_width - list_width) : move_total; 
                      move_total = Math.floor(move_total); 
                      $('#top-menu-ul .item_menu_Box').stop().animate({ scrollLeft: move_total }, 600); 
                  }
              }else{
                  var m_switch = 0;
                  for (var k = 0; k < i ; k++) {
                      if(m_switch == 0 && newscroll < sumArray[k]){                        
                          m_switch = 1;
                          move_total = Math.floor(sumArray[k]);
                          $('#top-menu-ul .item_menu_Box').stop().animate({ scrollLeft: move_total }, 600);  
                          j = k+1;
                      }
                  }
              }
              return false;
          });
          $("#top-menu-ul .flex-prev").on('click',function() {
              if(newscroll == move_total){
                  if(move_total > 0 && j>0){
                      j--;
                      move_total = 0;
                      for (var k = 0; k < j ; k++) move_total += move[k];
                      move_total = move_total > (total_width - list_width) ? (total_width - list_width) : move_total;  
                      move_total = Math.floor(move_total);
                      $('#top-menu-ul .item_menu_Box').stop().animate({ scrollLeft: move_total }, 600);
                  }
              }else{
                  var m_switch = 0;
                  for (var k = j; k >=0; k--) {
                      if(m_switch == 0 && newscroll > sumArray[k]){                        
                          m_switch = 1;
                          move_total = Math.floor(sumArray[k]);
                          $('#top-menu-ul .item_menu_Box').stop().animate({ scrollLeft: move_total }, 600); 
                          j = k+1; 
                      }
                  }
              }
          return false;
          });            
      }
    }
  /* ==========================================================================
                * slick
    ==========================================================================*/
  $('.banner-bx').slick({
    dots: true,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  });

  $('.aboutPage .it3-list').slick({
    dots: true,
    infinite: true,
    speed: 500,
    fade: false,
    cssEase: 'linear',
    autoplaySpeed: 5000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    responsive:[
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay:true,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay:true,
        }
      }
    ]
  });
/* ==========================================================================
                  * resize
      ==========================================================================*/
      var windowHeight = $(window).height();
      var miniHeight = windowHeight - $('footer').outerHeight();
        $('main').css({
          "min-height":miniHeight + "px"
        });

      $(window).on('resize', function(event) {
        var windowHeight = $(window).height();
        var miniHeight = windowHeight - $('footer').outerHeight();
        
        $('main').css({
          "min-height":miniHeight + "px"
        });

        if($(this).width() > 980){
            $('body,html,footer').removeAttr("style");
            $('.header_box').removeClass('open').removeAttr('style');
            $('.nav_box').removeAttr("style");
            $('.hamburger-menu').removeClass('animate').removeAttr("style");
        }

      });
      

      /* ==========================================================================
                * header-menu
    ==========================================================================*/
    $('.menu-wrapper').on('click', function() {
      if (!$('.hamburger-menu').hasClass('animate')) {
          $('.hamburger-menu').addClass('animate');
          $('.hamburger-menu').removeClass('colsanimate');
          $('.nav_box').addClass('navop').stop().fadeIn();
          $('.navopbg').addClass('navbgop');
          $('.header_box').addClass('open');
          $('body,html').css({ 'overflow': 'hidden' }).addClass('ops');
          $('footer').css({ 'z-index': '-1' });
          
      } else {
          $('.hamburger-menu').addClass('colsanimate');
          $('.hamburger-menu').removeClass('animate');
          $('footer').removeAttr("style");
          $('.nav_box').removeClass('navop').stop().fadeOut();
          $('.navopbg').removeClass('navbgop');
          $('.header_box').removeClass('open');
          $('body,html,.sub_menu').removeAttr("style").removeClass('ops');
          $('.product_bottom').removeClass('active').removeAttr('style');
      }
  });



  /* ==========================================================================
                * popup
    ==========================================================================*/
    // $('.h-wlogo').click(function() {
    //   $('.pop-act').addClass('show-pop');
    //   $('body,html').css({ 'overflow': 'hidden' });
    // })

    // $('.clos-btn').click(function() {
    //   $('.pop-act').removeClass('show-pop');
    //   $('body,html,.sub_menu').removeAttr("style");
    // })
    // $('.pop-act').click(function() {
    //   var x = event.target;
    //   $(x).addClass('popherecols');
    //   $(x).removeClass('show-pop');
    //   $(x).removeClass('popherecols');
    //   $('body,html,.sub_menu').removeAttr("style");
    // })


  /* ==========================================================================
                * scrollStyle
    ==========================================================================*/
  // $('testscroll').mCustomScrollbar();


  $(window).on('scroll', function () {
    var scrollTop = $(this).scrollTop();
    var top = $('.top_btn');
    var screenHeight = $(window).height();
    var scrollTop2 = $(this).scrollTop() + (screenHeight / 2);
    if(scrollTop > 99){
      $('.header_show').addClass('chheader');
    } else{
      $('.header_show').removeClass('chheader');
    }
    if(scrollTop > 170) {
      top.addClass('show-topbtn');
    } else {
      top.removeClass('show-topbtn');
      }

      var top_number;
      if ($(this).width() >= 768) {
          top_number = 450;
      } else {
          top_number = 300;
      }
      if (scrollTop2 >= $('footer').offset().top - top_number) {
          top.addClass('fix');
      } else if (scrollTop2 <= $('footer').offset().top + 400) {
        top.removeClass('fix');
      }
  })
  /* ==========================================================================
                * 內頁active 請分散到各頁下面script
    ==========================================================================*/

    // $('.nav_box ul li:nth-child(1) a').addClass('active');
    // $('.nav_box ul li:nth-child(2) a').addClass('active');
    // $('.nav_box ul li:nth-child(3) a').addClass('active');
    // $('.nav_box ul li:nth-child(4) a').addClass('active');
    // $('.nav_box ul li:nth-child(5) a').addClass('active');
  /* ==========================================================================
                * top-btn
    ==========================================================================*/


    $(".top_btn").click(function() {
      $("html,body").animate({ scrollTop: 0 }, 1000, 'easeOutExpo');
      return false;
  });


   /* ==========================================================================
                * textarea
    ==========================================================================*/

    var textAreaWrapper = $('.textarea-wrapper');
    var textArea=$("form textarea");

        var textArea=$("form textarea");
        textArea.wrap("<div class='textarea-wrapper' />");
        var textAreaWrapper=textArea.parent(".textarea-wrapper");
        textAreaWrapper.mCustomScrollbar({
            scrollInertia:5,
            mouseWheel:true,
            contentTouchScroll:25,
            autoExpandScrollbar:false,
        });
        var hiddenDiv=$(document.createElement("div")),
            content=null;
        hiddenDiv.addClass("hiddendiv");
        $("body").prepend(hiddenDiv);
        textArea.bind("keyup",function(e){
            content=$(this).val();
            var clength=content.length;
            var cursorPosition=textArea.getCursorPosition();
            content="<span>"+content.substr(0,cursorPosition)+"</span>"+content.substr(cursorPosition,content.length);
            content=content.replace(/\n/g,"<br />");
            hiddenDiv.html(content+"<br />");
            $(this).css("height",hiddenDiv.height());
            textAreaWrapper.mCustomScrollbar("update");
            var hiddenDivSpan=hiddenDiv.children("span"),
                hiddenDivSpanOffset=0,
                viewLimitBottom=(parseInt(hiddenDiv.css("min-height")))-hiddenDivSpanOffset,
                viewLimitTop=hiddenDivSpanOffset,
                viewRatio=Math.round(hiddenDivSpan.height()+textAreaWrapper.find(".mCSB_container").position().top);
            if(viewRatio>viewLimitBottom || viewRatio<viewLimitTop){
                if((hiddenDivSpan.height()-hiddenDivSpanOffset)>0){
                    textAreaWrapper.mCustomScrollbar("scrollTo",hiddenDivSpan.height()-hiddenDivSpanOffset);
                }else{
                    textAreaWrapper.mCustomScrollbar("scrollTo","top");
                }
            }
        });
        $.fn.getCursorPosition=function(){
            var el=$(this).get(0),
                pos=0;
            if("selectionStart" in el){
                pos=el.selectionStart;
            }else if("selection" in document){
                el.focus();
                var sel=document.selection.createRange(),
                    selLength=document.selection.createRange().text.length;
                sel.moveStart("character",-el.value.length);
                pos=sel.text.length-selLength;
            }
            return pos;
        }
  
  /* ==========================================================================
    * banner
  ==========================================================================*/

      // 先宣告  (編號值,x,x)
      //初始化
      var bannerIndex = new Array();
      var nextIndex = new Array();
      var prevIndex = new Array();
      var alllength = new Array();
      var stopSlider = new Array();

      function setSlider(id, ele){
        bannerIndex[id] = 0;
        nextIndex[id] = 0;
        prevIndex[id] = 0;
        alllength[id] = ele;
        stopSlider[id] = '';
      }

      function chbanner (id) {
      nextIndex[id] = bannerIndex[id] + 1;
      prevIndex[id] = bannerIndex[id] - 1;
      if( bannerIndex[id] == alllength[id] - 1) nextIndex[id] = 0;
      if( bannerIndex[id] == 0) prevIndex[id] = alllength[id] - 1;
      // 換圖開始
      switch(id) {
        case 1:
          $('.pc-banner .it').removeClass('chbanner').stop().fadeOut();
          $('.mo-banner .it').removeClass('chbanner').stop().fadeOut();
          $('.show-box .go-it').removeClass('show-me');
          $('.show-box .go-it').eq(bannerIndex[id]).addClass('show-me');
          $('.pc-banner .it').eq(bannerIndex[id]).addClass('chbanner').stop().fadeIn();
          $('.mo-banner .it').eq(bannerIndex[id]).addClass('chbanner').stop().fadeIn();
          break;
        case 2:
          $('.pc-banner2 .it').removeClass('chbanner').stop().fadeOut();
          $('.mo-banner2 .it').removeClass('chbanner').stop().fadeOut();
          $('.show-box2 .go-it').removeClass('show-me');
          $('.show-box2 .go-it').eq(bannerIndex[id]).addClass('show-me');
          $('.mo-show-box2 .go-it').removeClass('show-me');
          $('.mo-show-box2 .go-it').eq(bannerIndex[id]).addClass('show-me');
          $('.pc-banner2 .it').eq(bannerIndex[id]).addClass('chbanner').stop().fadeIn();
          $('.mo-banner2 .it').eq(bannerIndex[id]).addClass('chbanner').stop().fadeIn();
          break;
      }
      // 換圖結束
      bannerIndex[id] = nextIndex[id] ;
      }

      function makSlider(id , mode , type){
        id = id || 1; // Slider編號
        mode = mode || 1; // 1:一開始觸發  2:左右按鍵  3: 豆豆
        type = type || 0; // 判斷左右時 1:左 2:右 / mode 3時 為索引值
        
        clearInterval(stopSlider[id]);
        switch(mode) {
          case 2:
            if(type == 1) bannerIndex[id] = prevIndex[id];
            else bannerIndex[id] = nextIndex[id];
            break;
          case 3:
            bannerIndex[id] = type;
            break;
        }
        chbanner(id);
        stopSlider[id] = setInterval(chbanner,5000,id);
      }

      //宣告
      setSlider(1, $('.pc-banner .it').length);
      setSlider(2, $('.pc-banner2 .it').length);
      makSlider(1,1);
      makSlider(2,1);

      $('.go-it').click(function(){
        var goIndex = $(this).index();
        makSlider(1 , 3 , goIndex);
      });
      // $('.go-it').click(function(){
      //   var goIndex = $(this).index();
      //   makSlider(2 , 3 , goIndex);
      // });
      // $('.arr-box .left').click(function(){
      //   var goIndex = $(this).index();
      //   makSlider(2 , 2 , 1);
      // });
      // $('.arr-box .right').click(function(){
      //   var goIndex = $(this).index();
      //   makSlider(2 , 2 , 2);
      // });




})

